export default __webpack_public_path__ + "static/media/kerry.666ceb95.jpeg";